import UniversalLoginRedirect from 'components/auth/UniversalLoginRedirect';

export default function SignInDefault() {
  return <UniversalLoginRedirect />;
}
